"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointDisabledEvent = void 0;
class EndpointDisabledEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointDisabledEvent.attributeTypeMap;
    }
}
exports.EndpointDisabledEvent = EndpointDisabledEvent;
EndpointDisabledEvent.discriminator = undefined;
EndpointDisabledEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "EndpointDisabledEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "EndpointDisabledEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=EndpointDisabledEvent.js.map